import { Button, Flex } from '@endurancewarranty/ui';

import type { FC } from 'react';

type Props = Readonly<{
  isLoading: boolean;
  nextText: string;
  onNextClick: () => void;
  closeText?: string;
  onClose?: () => void;
}>;

export const QuoteTransactionModalFooter: FC<Props> = ({
  isLoading,
  nextText,
  onNextClick,
  closeText = 'Close',
  onClose,
}) => {
  return (
    <Flex
      className="absolute bottom-0 left-0 h-20 w-full gap-1 border-t border-bcolor-50 px-4"
      items="center"
      justify="end">
      {onClose != null && (
        <Button name="quote-transaction-modal-close-button" variant="secondary" onClick={onClose}>
          {closeText}
        </Button>
      )}
      <Button
        name="quote-transaction-modal-next-button"
        variant="primary"
        isDisabled={isLoading}
        onClick={onNextClick}>
        {nextText}
      </Button>
    </Flex>
  );
};
